<section class="hero-slider">
  <ngx-slick-carousel *ngIf="slides.length > 0" class="hero-slider__carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slides" class="hero-slider__slide">

      <div class="hero-slider__image-wrap">
        <img class="hero-slider__image" [src]="slide.image" [alt]="slide.headlineLineOne" [style.objectPosition]="slide.objectPosition">
        <div class="hero-slider__overlay"></div>
      </div>

      <div class="hero-slider__content-wrap">
        <div class="hero-slider__card">
          <span class="hero-slider__rule"></span>
          <p class="hero-slider__eyebrow">{{ slide.eyebrowZh }}</p>
          <p class="hero-slider__eyebrow hero-slider__eyebrow--sub">{{ slide.eyebrowEn }}</p>
          <h1 class="hero-slider__headline font-display">
            {{ slide.headlineLineOne }}<br><em>{{ slide.headlineLineTwo }}</em>
          </h1>
          <p class="hero-slider__tagline font-display">{{ slide.tagline }}</p>
          <p class="hero-slider__body">{{ slide.bodyZh }}</p>
          <p class="hero-slider__body hero-slider__body--sub" *ngIf="slide.bodyEn">{{ slide.bodyEn }}</p>
          <div class="hero-slider__ctas">
            <a class="hero-slider__cta hero-slider__cta--primary" [href]="slide.primaryCtaHref">{{ slide.primaryCtaLabel }}</a>
            <a class="hero-slider__cta hero-slider__cta--secondary" [href]="slide.secondaryCtaHref">{{ slide.secondaryCtaLabel }}</a>
          </div>
        </div>
      </div>

    </div>
  </ngx-slick-carousel>
</section>
